const getTabLabel = (tab) => tab?.textContent?.trim() || '';

export const installRealPennedFieldsDefault = (container) => {
  if (!container) {
    return () => {};
  }

  let openTimer;
  let settled = false;

  const openFieldsWhenReady = () => {
    const tabs = Array.from(container.querySelectorAll('.polotno-side-panel-tab'));

    if (!tabs.length) {
      return false;
    }

    const isRealPennedSidebar =
      tabs.length === 2 &&
      getTabLabel(tabs[0]) === 'Templates' &&
      getTabLabel(tabs[1]) === 'Fields';

    if (!isRealPennedSidebar) {
      settled = true;
      return true;
    }

    // Do not override a choice the user made while the SDK was rendering.
    if (tabs.some((tab) => tab.classList.contains('active'))) {
      settled = true;
      return true;
    }

    settled = true;
    tabs[1].click();
    return true;
  };

  const scheduleOpen = () => {
    if (settled || openTimer) {
      return;
    }

    openTimer = window.setTimeout(() => {
      openTimer = undefined;

      if (openFieldsWhenReady()) {
        observer.disconnect();
      }
    }, 0);
  };

  const observer = new MutationObserver(scheduleOpen);
  observer.observe(container, { childList: true, subtree: true });
  scheduleOpen();

  return () => {
    window.clearTimeout(openTimer);
    observer.disconnect();
  };
};
